module.exports = __webpack_public_path__ + "static/form-with-image-image-lg-53ee8f9a301f47d99e3625e540786ad8.jpg";